import { render, staticRenderFns } from "./DefaultContent-CategoryCard.vue?vue&type=template&id=be5e1144&"
import script from "./DefaultContent-CategoryCard.vue?vue&type=script&lang=js&"
export * from "./DefaultContent-CategoryCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports